import React from 'react';

function CodeBlock({ code, language }) {
  const copyCode = () => {
    navigator.clipboard.writeText(code);
  };

  return (
    <div className="code-block">
      <div className="code-header">
        <span className="code-language">{language || 'code'}</span>
        <button className="code-copy-btn" onClick={copyCode}>
          Copy
        </button>
      </div>
      <pre className="code-content">
        <code>{code}</code>
      </pre>
    </div>
  );
}

export default CodeBlock;
